
import React from "react";
import { Link } from "react-router-dom";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { getAuthorProfile } from "@/data/authors";

interface PostHeaderProps {
  title: string;
  date: string;
  author: string;
  imageSrc: string;
  hasBodyH1?: boolean;
}

const PostHeader = ({ title, date, author, imageSrc, hasBodyH1 = false }: PostHeaderProps) => {
  const TitleElement = hasBodyH1 ? "div" : "h1";
  const authorProfile = getAuthorProfile(author);

  return (
    <div className="w-full relative">
      <div className="container mx-auto px-4 py-8">
        <AspectRatio ratio={16/9} className="w-full overflow-hidden rounded-lg">
          <img
            src={imageSrc}
            alt={title}
            loading="eager"
            fetchPriority="high"
            width="1200"
            height="675"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
            <div className="container mx-auto px-4 pb-8">
              <TitleElement className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2">
                {title}
              </TitleElement>
              <div className="flex items-center text-white/80">
                <span>{date}</span>
                <span className="mx-2">•</span>
                {authorProfile.href ? (
                  <Link
                    to={authorProfile.href}
                    className="hover:text-white hover:underline underline-offset-2"
                    aria-label={`About ${authorProfile.displayName}`}
                  >
                    {authorProfile.displayName}
                  </Link>
                ) : (
                  <span>{authorProfile.displayName}</span>
                )}
              </div>
            </div>
          </div>
        </AspectRatio>
      </div>
    </div>
  );
};

export default PostHeader;
